// removed by extract-text-webpack-plugin
module.exports = {"share-button-container":"_3s-Dq","share-button":"_1JyeN","copy":"_19i2G","url":"ncSxX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ShareModal/CopyLinkShareButton.scss
// module id = ./src/components/ShareModal/CopyLinkShareButton.scss
// module chunks = 4